export const THUMBNAIL_PLACEHOLDER =
  "https://evodream.nyc3.cdn.digitaloceanspaces.com/thumbs/exercice-placeholder-black.png";

export const THUMBNAIL_PLACEHOLDER_GRAY =
  "https://evodream.nyc3.cdn.digitaloceanspaces.com/thumbs/program-placeholder-gray.png";
